export default __webpack_public_path__ + "static/media/Alesha 9781408312889.21046f33.jpg";